{
  "zh-CN": {
    "texts": {
      "user": {
        "maintainer": "获得维护者徽章以及最高等级的所有支持者福利。"
      },
      "index": "Your database for all information around Ships and Stations in Star Citizen.",
      "indexQuote": "“Strap into one of dozens of ships and embark on a life within the Star Citizen universe.<br>Unbound by profession or skill sets, you choose the path of your own life.”",
      "indexQuoteSource": "Author Unknown, Source:",
      "support": {
        "info": "不方便捐助？<a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>在 Spectrum 为我们点赞</b></a>，让更多人发现 FleetYards。",
        "goal": "用于服务器托管和数据服务等日常运营开支。",
        "code": "刚接触星际公民？使用此邀请码可获得 5000 UEC 初始资金：",
        "thisMonth": "本月目标 %{goal}",
        "subline": "直接支持我们",
        "otherWays": "其他帮助方式"
      },
      "appUpdate": {
        "withCodename": "FleetYards %{version}（%{codename}）已上线。重新加载即可切换。",
        "plain": "FleetYards %{version} 已上线。重新加载即可切换。"
      },
      "installApp": {
        "eventSignup": "将 FleetYards 安装为应用，一键返回你的活动。",
        "iosIntro": "在 iPhone 和 iPad 上，可以通过分享菜单安装 FleetYards 这样的应用：",
        "iosShare": "轻点浏览器工具栏中的“分享”按钮。",
        "iosAdd": "选择“添加到主屏幕”，可能需要向下滚动才能找到。",
        "iosConfirm": "轻点“添加”。现在可以像其他应用一样从主屏幕打开 FleetYards。"
      },
      "supportHint": {
        "hangarSync": "后台同步是我们托管账单中最大的一项支出。FleetYards 依靠捐赠运行 — 任何支持都很重要。",
        "vehicleAdded": "FleetYards 免费、无广告,完全依靠捐赠运行。如果它对你有帮助,一份小小的捐助就能维持它的运转。",
        "fleetCreated": "舰队是我们最耗资源的功能之一。FleetYards 凭借捐赠保持免费和无广告 — 欢迎你也加入支持。",
        "loginMilestone": "你已经陪伴我们一段时间了 — 谢谢。FleetYards 依靠捐赠运行;如果你愿意帮忙分担费用,这里可以了解更多。",
        "visitMilestone": "FleetYards 由社区资助 — 没有广告,没有付费墙。如果你觉得它有用,一份小小的捐赠就能起到很大作用。"
      },
      "notFound": "You are currently venturing unknown space. In the event you are lost, the UEE highly recommends plotting a new destination back towards home-space.",
      "forbidden": "你的权限不包含此区域。如果某项功能仍在灰度发布中，等它对你开放后，可以在“设置 > 功能”中自行开启。",
      "subscriptionRequired": "合约、活动、Logistics 和行程由支持 FleetYards 的人共同维持。该舰队目前未在覆盖范围内 — 任何一位成员的捐助都会为整个舰队开启这四项功能。",
      "featureNotReady": "此功能尚未完成，即将推出。敬请期待！",
      "inviteInvalid": "此邀请链接无效。可能是输入有误、已过期，或已达到使用次数上限。请向邀请你的人索取新的链接。",
      "accessDenied": "您无权查看此页面。",
      "serverError": "服务器当前遇到技术问题。请稍后再试。",
      "offline": "请求未能到达服务器。你的设备似乎已离线，或者无法连接到服务器。请检查网络连接后重试。",
      "invalidRequest": "服务器无法处理此请求。请刷新页面后重试。",
      "invalidListRequest": "此过滤器或排序无效。请重置后重新显示列表。",
      "compare": {
        "ships": {
          "info": "To start select at least two and not more than eight Ships you want to compare."
        }
      },
      "fleets": {
        "leaveInfo": "You can not leave a Fleet as an Admin.",
        "directory": "选择被发现的已验证舰队。这里的每支舰队都已证明它管理着自己的 RSI 组织。"
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "恢复已清除的舰队只是尽力而为。角色、图片、邀请链接和舰队载具不会被恢复。"
        },
        "models": {
          "viewsFolder": {
            "hint": "拖入一个视图文件夹，文件命名为 top.png、side.png、front.png 和 angled.png。带涂装的一组加后缀 _colored，展开状态的一组加前缀 extended_，着陆状态的一组加前缀 landed_。前缀 flight_ 或不加前缀都会归入默认组。holo.gltf 也会一并上传，前缀规则相同。从后方和下方的视图命名为 angled_rear.png、bottom.png、rear.png 和 starboard.png。不含内饰的 holo_lite.glb 使用相同的前缀；holo_textured.glb 只会归入默认组。",
            "uploading": {
              "one": "正在上传 1 个文件…",
              "other": "正在上传 %{count} 个文件…"
            },
            "matched": {
              "one": "1 个文件已就绪 — 保存以应用。",
              "other": "%{count} 个文件已就绪 — 保存以应用。"
            },
            "processing": {
              "one": "正在后台裁剪 1 个视图 — 完成后会在此更新。",
              "other": "正在后台裁剪 %{count} 个视图 — 完成后会在此更新。"
            },
            "processed": "所有视图均已处理完毕。",
            "ignored": "已忽略: %{files}"
          }
        },
        "oauthApplications": {
          "rejectHint": "该原因会展示给注册此应用的人，请说明需要修改什么。"
        }
      },
      "hangarTour": {
        "welcome": {
          "title": "欢迎来到你的机库",
          "text": "你的机库记录着你拥有的每一艘舰船。这个简短的导览会告诉你各项功能在哪里——你可以随时通过 ? 按钮重新开始。"
        },
        "add": {
          "title": "添加舰船",
          "text": "选择一艘或多艘舰船以及各自的数量。在任意舰船的页面或卡片上，书签图标也能将它添加到你的机库或愿望单。"
        },
        "sync": {
          "title": "从 RSI 同步",
          "text": "使用 FleetYards 浏览器扩展从 RSI 同步舰船、涂装、装饰品和装备。每次同步后请查看结果。回购列表可在回购页面单独同步。"
        },
        "display": {
          "title": "显示选项",
          "text": "在卡片和列表之间切换，设置默认排序，并选择显示哪些详情或列。在列表中可以同时选中多艘舰船一起修改。"
        },
        "groups": {
          "title": "分组",
          "text": "用 + 和铅笔按钮把舰船整理到你自己的分组中。点击分组可按其筛选，悬停可高亮其中的舰船。"
        },
        "vehicle": {
          "title": "每艘舰船的菜单",
          "text": "在这里编辑舰船：命名、选择涂装、设为旗舰、设置可见性、管理配装，或移到愿望单。"
        },
        "wishlist": {
          "title": "愿望单",
          "text": "将想要但尚未拥有的舰船放入愿望清单，获得后再移入机库。"
        },
        "fleetchart": {
          "title": "舰队图",
          "text": "按比例并排展示你的舰船，并将图表保存为图片。"
        },
        "stats": {
          "title": "统计",
          "text": "角色、制造商、尺寸以及你的花费，支持 CSV 导出。"
        },
        "share": {
          "title": "分享你的机库",
          "text": "分享公开机库，并选择显示哪些舰船和分组。你还可以在机库设置中创建、更换或停用秘密链接，即使机库设为私密也能使用。任何持有该链接的人都能查看你的机库及其统计数据。"
        },
        "menu": {
          "title": "更多",
          "text": "在此导入或导出机库，或查看导入历史。在手机上，此菜单还包含愿望清单、舰队图、统计数据、质押物品和本导览。"
        },
        "overview": {
          "title": "舰船的专属页面",
          "text": "点击舰船标题打开概览，管理配置与可见性、撰写船长日志并上传图片。为拥有的舰船添加题词铭牌，并保存为图片。每篇日志都有独立的可见性设置。"
        },
        "pledgeItems": {
          "title": "不只有舰船",
          "text": "从此菜单打开涂装、装饰品或装备，浏览从 RSI 机库同步的物品。回购项目单独列出，可在其页面同步。"
        },
        "reset": {
          "title": "游戏清档之后",
          "text": "在此重置游戏内购买的舰船：将它们全部移入愿望清单作为购物清单，或从机库中移除。使用真实货币购买的舰船会保留。"
        },
        "inventories": {
          "title": "机库库存",
          "text": "跟踪各地点的物品、记录存入和取出，并在机库库存中管理转移。"
        },
        "exampleShip": {
          "title": "示例舰船",
          "text": "仅用于导览，不会保存到你的机库。"
        }
      },
      "fleetTour": {
        "welcome": {
          "title": "你的舰队已就绪",
          "text": "这个导览会依次打开设置舰队的每个页面，并指出其中的关键选项。随时点击舰队页面顶部的问号即可重新查看。"
        },
        "events": {
          "title": "活动与任务",
          "text": "规划行动，让成员报名舰船和座位，并把一切安排在舰队日历中。"
        },
        "contracts": {
          "title": "合同",
          "text": "为成员发布任务，并在完成后向他们付款。"
        },
        "members": {
          "title": "邀请成员",
          "text": "通过 Fleetyards 用户名邀请成员，或创建邀请链接分享到 Discord 或 RSI。加入申请也会出现在此页面。"
        },
        "ships": {
          "title": "舰船与舰队图",
          "text": "成员共享的舰船共同组成舰队的舰船。舰队图会将它们按比例并排展示。"
        },
        "membership": {
          "title": "你在舰队中的舰船",
          "text": "每位成员决定舰队能看到自己的哪些舰船：全部、某个机库分组或不显示。这里是你自己的选择。"
        },
        "rsi": {
          "title": "验证你的 RSI 组织",
          "text": "输入你组织的 SID 并进行验证。验证可以证明该组织属于你，并保护你的舰队 ID。"
        },
        "roles": {
          "title": "角色",
          "text": "每个角色决定其成员可以查看和管理哪些内容。此页面列出了每个角色的权限。"
        },
        "squadrons": {
          "title": "中队与小组",
          "text": "开启中队功能，将成员划分为各自拥有军衔的单位和小组。"
        },
        "discord": {
          "title": "连接 Discord",
          "text": "在你的 Discord 服务器上安装机器人，为每个军衔分配一个 Discord 角色，并将活动同步为预定活动。"
        },
        "settings": {
          "title": "公开舰队页面",
          "text": "决定舰队页面及其舰船是否公开；徽标、简介和链接也在此页面。"
        },
        "finish": {
          "title": "你的舰队已设置完成",
          "text": "入门所需的就是这些。随时点击上方的问号即可重新查看此导览。"
        }
      },
      "hangarPreview": {
        "sync": {
          "title": "从 RSI 同步",
          "text": "通过浏览器扩展或 hangarXPLOR 文件导入你的 pledge，无需逐艘添加舰船。"
        },
        "organise": {
          "title": "整理你的舰船",
          "text": "为舰船命名，设置涂装、配装和旗舰，并整理到你自己的分组中。"
        },
        "wishlist": {
          "title": "愿望单与促销",
          "text": "把想要的舰船放进愿望单，开售时收到通知。"
        },
        "fleetchart": {
          "title": "舰队图",
          "text": "按比例并排查看你的舰船，并将图表保存为图片。"
        },
        "stats": {
          "title": "机库统计",
          "text": "角色、制造商、尺寸以及你的花费，一目了然。"
        },
        "share": {
          "title": "公开机库",
          "text": "通过链接分享你的机库——哪些舰船和分组可见由你决定。"
        }
      },
      "fleetPreview": {
        "members": {
          "title": "成员与角色",
          "text": "通过链接邀请组织成员，并用角色和中队来管理他们。"
        },
        "ships": {
          "title": "舰队舰船",
          "text": "所有成员的公开舰船汇集在一个可筛选、可搜索的列表中。"
        },
        "fleetchart": {
          "title": "舰队图",
          "text": "按比例并排查看整个舰队，并保存为图片。"
        },
        "stats": {
          "title": "舰队统计",
          "text": "按角色、尺寸和货运容量分析你的舰队。"
        },
        "allies": {
          "title": "盟友",
          "text": "与其他舰队结盟，随时了解与你并肩飞行的伙伴。"
        },
        "discord": {
          "title": "Discord",
          "text": "在你的 Discord 服务器发布公告和每周摘要，并让成员通过身份组加入。"
        }
      },
      "impressum": {
        "visit": "访问",
        "ytShipImages": "The Awesome Ship Images in the Hangar Fleetchart view are the work of <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br>Please visit his Spectrum post (see links below) and give him a upvote.",
        "erkul": "The ship metrics on Fleetyards are modelled on the formulas and readouts of Erkul's DPS Calculator. Thanks to the erkul.games team for sharing their work with the community.",
        "appSignal": "AppSignal provided a sponsored Open Source Account which helps to improve Fleetyards.net even further. Thanks :)",
        "copyright": "The contents and works created by the page operators, on these pages are subject to German copyright. Duplication, processing, distribution and any kind of exploitation outside the limits of Copyright require the written consent of the respective author or creator. Downloads and copies of this page are only for private, non-commercial use. Insofar as the content on This page was not created by the operator, are third-party copyrights respected. In particular, Third-party content as such. Please Contact us if you notice any sort of copyright infringement. We will remove any content immediately as we become aware of such violations.",
        "disclaimer": {
          "p1": "This is an unofficial Star Citizen fansite, not affiliated with the Cloud Imperium group of companies.",
          "p2": "All content on this site not authored by its host or users are property of their respective owners.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. All rights reserved."
        },
        "liabilityInternal": {
          "p1": "The content of out site has been compiled with meticulous care and to the best of our knowledge. However, We cannot assume any liability for the up-to-dateness, completeness or accuracy of any of the pages.",
          "p2": "Pursuant to section 7, para. 1 of the TMG (Telemediengesetz), We are liable for our own content on these pages in accordance with general laws. However, pursuant to sections 8 to 10 of the TMG, We are not under obligation to monitor external information provided or stored on our site. Once We have become aware of a specific infringement of the law, We will immediately remove the content in question. Any liability concerning this matter can only be assumed from the point in time at which the infringement becomes known to us."
        },
        "liabilityExternal": "Our site contains links to websites of third parties (“external links”). As the content of these sites is not under our control, We cannot assume any liability for such external content. In all cases, the provider of information of the linked sites is liable for the content and accuracy of the information provided. At the point in time when the links were placed, no infringements of the law were recognisable to us. As soon as an infringement of the law becomes known to us, We will immediately remove the link in question."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "我们使用哪些信息?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "作为访客",
          "text": "作为 %{app} 的访客，我们收集以下数据："
        },
        "analytics": {
          "headline": "使用情况分析",
          "basis": "%{app} 会统计页面访问量，以了解网站的哪些部分真正被使用。这基于我们运营和改进网站的合法利益，而非您的同意: 数据仅由我们第一方收集，IP 地址在存储前已匿名化，不会在您的设备上放置 Cookie 或其他标识符，也不会与任何广告网络共享。",
          "retention": "单次访问和页面浏览记录会在一个月后删除。此后仅保留无法追溯到个人的汇总数据。删除您的账户也会同时删除为其记录的访问数据。",
          "objection": {
            "headline": "如何反对",
            "text": "您可以随时反对使用情况分析，我们会真正停止记录，而不仅仅是将其隐藏。",
            "user": "您在“设置”中的账户选项会应用到您登录的每一台设备。",
            "guest": "没有账户时，您可以在此反对。如果您的浏览器发送了 Global Privacy Control 信号，我们也会予以尊重。"
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "匿名统计您访问的页面，不会在您的设备上存储任何内容。访问记录会在一个月后删除。",
          "onlineStatus": "只要你打开着 FleetYards，你所在舰队的成员和你的好友就会在你的名字旁看到一个圆点。你的最近活动时间始终可见。",
          "supporterListed": "你的用户名（绝不会是付款时使用的名字）是否显示在支持者页面上。隐藏的捐赠仍计入目标；除非你选择显示，Patreon 赞助保持隐藏。"
        },
        "notifications": {
          "hint": "选择每类事件如何通知您。应用内通知会汇集在您的通知中心，邮件将发送到您账户的邮箱地址。",
          "push": {
            "title": "推送通知",
            "intro": "即使 FleetYards 已关闭，也能在此设备上收到通知。在下方的“推送”列中选择哪些通知以推送方式送达。",
            "unsupported": "此浏览器无法接收推送通知。在 iPhone 或 iPad 上，请先将 FleetYards 添加到主屏幕，然后从那里打开。",
            "denied": "此浏览器已阻止 FleetYards 的通知。请在浏览器的网站设置中允许通知，然后重新加载此页面。",
            "on": "此设备已开启推送通知。",
            "off": "此设备已关闭推送通知。",
            "device": "%{os} 上的 %{browser}",
            "unknownDevice": "未知浏览器",
            "thisDevice": "（此设备）",
            "failed": "无法检查此设备的推送通知状态。请重新加载页面后重试。"
          }
        }
      },
      "signup": {
        "blocked": "You have been blocked from FleetYards.net.<br>This can have multiple Reasons.<br>For further Information please Contact us under info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "This Item was removed from the Roadmap. This is its last location"
      },
      "twoFactor": {
        "backupCodes": "Save a copy of your Backup-Codes. They will only be visible this one time.",
        "disable": "要禁用两步验证，只需输入一个有效的令牌。",
        "enable": " To secure your FleetYards.net Account you can generate 2-Factor-Auth Tokens with Google Authenticator, 1Password or Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "%{clientName} 正在请求访问您的账户。",
        "scopesIntro": "此应用将能够："
      },
      "buybackSync": {
        "info": "读取你的 RSI 回购列表的每一页，并用它替换 Fleetyards 上保存的可回购承诺。你的机库不会被改动。列表较长时需要几分钟。同步在后台进行：只要标签页保持打开，你可以关闭此窗口并继续使用 Fleetyards。",
        "unsupported": "你的 Fleetyards Sync 扩展还无法读取可回购的承诺。请更新扩展以同步它们。",
        "detailsInfo": "首次同步还会读取每个承诺的价格和保险，每个承诺一个 RSI 页面，列表较长时可能需要十五分钟左右。之后的同步只读取新的承诺。",
        "detailsUnsupported": "请更新你的 Fleetyards Sync 扩展，以便同时读取价格和保险。",
        "detailsIncomplete": "部分价格无法从 RSI 读取。下次同步时会重试。",
        "detailsBackground": "价格和保险现在在后台读取。你可以关闭此窗口并继续使用 Fleetyards；在完成之前请保持此标签页打开。",
        "detailsRunning": "上次同步的价格和保险仍在读取中。完成后才能开始新的同步。",
        "sessionHint": "同步会通过此会话读取你的回购列表。",
        "pointReplace": "读取你的 RSI 回购列表的每一页，并用它替换这里保存的可回购承诺。",
        "pointUntouched": "你的机库不会被改动。",
        "pointBackground": "在后台运行：你可以关闭此窗口，只需保持标签页打开。",
        "finished": "你的可回购承诺与 RSI 列表一致。",
        "keepsRunning": "关闭此窗口后它仍会继续运行。请保持标签页打开，直到完成。"
      },
      "blueprintAddToHangar": {
        "ownHint": "你拥有这张蓝图。",
        "wishlistHint": "你想获得这张蓝图。",
        "unownHint": "你不再拥有这张蓝图。",
        "unwantHint": "你不再想要这张蓝图。"
      },
      "addToHangar": {
        "hangarHint": "你拥有这艘飞船。",
        "wishlistHint": "你想以后获得这艘飞船。"
      },
      "resetIngame": {
        "info": "数据重置会清除你在游戏内购买的飞船。你可以将它们移至愿望清单以便日后再次购买，或将它们从机库中移除。不是在游戏内购买的飞船不受影响。"
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "alreadyRunning": "机库同步已在进行中。请等待完成。",
        "missingUnmatchedGroup": "开始前，请选择用于归档同步找不到的飞船的分组。",
        "signedOutTitle": "你尚未登录 RSI",
        "signedOut": "请在此浏览器中登录 RSI 网站，然后再检查一次。",
        "sessionHint": "同步会通过此会话读取你的承诺。",
        "finished": "你的机库与 RSI 承诺一致，所有内容均已匹配。",
        "unmatched": "其余内容均已同步。下方列出的内容都没有添加到你的机库。",
        "partialFailure": "部分更改可能已写入你的机库。重试是安全的：已同步的舰船会重新匹配，不会重复添加。",
        "pointMatch": "按名称和承诺 ID，找出你 RSI 机库中已在这里的舰船。",
        "pointAdd": "添加尚未在这里的舰船。"
      },
      "setEmail": "要设置密码、启用双重认证或接收邮件通知，您需要为账户添加电子邮件地址。您将收到一封确认邮件来验证该地址。",
      "oauthApplications": {
        "pendingReview": "此应用已注册，正在等待审核。在获得批准前无法请求访问权限。",
        "rejected": "此应用已被拒绝，无法请求访问权限。按照原因中所述修改后会重新进入审核队列。",
        "returnedToReview": "修改重定向 URI 或权限范围会使已批准的应用重新进入审核。"
      },
      "payouts": {
        "accountFound": "%{username} 拥有 FleetYards 账户，将关联到此参与者。",
        "accountMissing": "没有使用此用户名的 FleetYards 账户。请检查拼写，或在下方按名称将其添加为访客。",
        "guestHint": "用于没有 FleetYards 账户的人，将显示为访客。",
        "deleteHint": "此行程尚无其他参与者，因此可以删除。",
        "tourInvite": "%{username} 邀请你加入此行程。",
        "contractReady": "合同已完成。打开分账账本，将报酬支付给承接人。",
        "contractNotReady": "此合同尚未开启分账账本。",
        "expenseNeedsReview": "支出需经账本管理者批准后才会计入。"
      },
      "fleet": {
        "contractCovers": "合约板为每种合约显示的图片。留空则使用下方的内置图片。"
      },
      "vehicleLog": {
        "visibility": "公开条目会随此舰船显示在你的公开机库中。",
        "visibilityHidden": "此舰船未列在你的公开机库中，因此那里不会显示它的任何条目。",
        "empty": "记录这艘舰船的经历——在你将条目设为公开之前，只有你能看到它。",
        "publicEmpty": "这艘舰船的舰长还没有分享任何日志条目。",
        "noneForFilter": "没有符合此筛选的条目。",
        "unavailable": "此日志暂时不可用。"
      },
      "vehiclePlaque": {
        "supporter": "其他所有样式，都是献给让 Fleetyards 持续运行的支持者们的谢礼。",
        "keptStyle": "你的铭牌保留了支持者专属的%{style}样式。保存后，它将切换为%{default}。",
        "credits": {
          "founders": "%{manufacturer}创始人",
          "shipwrights": "%{manufacturer}造船师",
          "designers": "%{manufacturer}设计师",
          "directors": "%{manufacturer}总监"
        },
        "fromFleet": "来自舰队",
        "classLine": "%{manufacturer} 出品的 %{model}",
        "commissioned": "建造于 %{shipyard}",
        "launched": "%{date} 下水",
        "launchedAt": "%{date} 于 %{port} 下水",
        "launchedFrom": "于 %{port} 下水",
        "captain": "舰长 %{name}",
        "captainOf": "舰长 %{name}，%{affiliation}",
        "year": "%{year}年%{month}",
        "empty": "还没有献词。写下一段，这艘船就有了自己的铭牌。",
        "visibility": "只要这艘船是公开的，任何人都能在你的公开机库中看到铭牌。"
      },
      "vehicleOverview": {
        "noLoadouts": "还没有配装。从 Erkul 或 SPViewer 链接一个。",
        "locationPrivate": "只有你能看到你的舰船在哪里。",
        "pickReplacesUpload": "从图库或涂装中选择图片会替换你上传的图片。",
        "galleryEmpty": "这艘舰船还没有图库图片。"
      },
      "model": {
        "sectionEmpty": "%{model} 没有任何%{section}。"
      },
      "hangarPledgeItems": {
        "addToInventory": "每项按其礼包所含数量添加。",
        "alreadyInInventory": {
          "other": "%{count} 项已在库存中，保持不变。"
        },
        "noInventories": "你还没有库存。请先创建一个，再添加物品。"
      }
    }
  }
}
